import React, { Fragment } from 'react';
// import PropTypes from 'prop-types';
import whatYouKnow from '../../assets/images/show-what-you-know.gif';
import whatYouLearned from '../../assets/images/show-what-you-learned.gif';
import Intro from '../Intro';
import Voiceover from '../Voiceover';
import PagerButton from '../PagerButton';
import './styles.styl';

export const ShowWhatYouKnowSpanish = ({
  direction,
  topic,
  image,
  lead,
  title,
  paragraphText,
  vo
}) => {
  const isKnown = window.location.href.indexOf('prepara') > 0;

  const determineTitle = () => {
    if (title) return title;
    return `Muestra lo que ${isKnown ? 'Sabes' : 'Aprendidos'}`;
  };

  const isKnownText = `Let’s see what you already know about ${topic}. Take this quiz to find out.`;

  const isLearnedText = `Ahora es el momento de ver lo que has aprendido sobre el ejercicio como una actividad esencial para ayudar a reducir el riesgo de desarrollar enfermedades no transmisibles y mantener la salud en general.  Antes de responder estas preguntas finales, puedes regresar a las secciones anteriores para revisar la información del módulo.`;

  const standardKnowVOTranscript = `Before we learn more about ${topic}, let’s see what you already know.
      Don’t worry. You aren’t expected to have all the answers yet! Just do the
      best you can.`;

  const standardLearnedVOTranscript = `Ahora es el momento de ver lo que has aprendido sobre el ejercicio como una actividad esencial para ayudar a reducir el riesgo de desarrollar enfermedades no transmisibles y mantener la salud en general.  Antes de responder estas preguntas finales, puedes regresar a las secciones anteriores para revisar la información del módulo.`;

  const determineVOTranscript = () => {
    if (vo.transcript) return vo.transcript;
    return isKnown ? standardKnowVOTranscript : standardLearnedVOTranscript;
  };

  const determineDescriptionText = () => {
    if (paragraphText) return paragraphText;
    return isKnown ? isKnownText : isLearnedText;
  };

  const determineImage = () => {
    if (image) return image;
    return isKnown ? whatYouKnow : whatYouLearned;
  };

  const voiceOver = {
    sources: [
      {
        src: vo.src
      }
    ],
    transcript: determineVOTranscript()
  };

  return (
    <Fragment>
      {vo && <Voiceover {...voiceOver} />}
      <Intro
        title={determineTitle()}
        lead={lead ? lead : ''}
        direction={direction ? direction : ''}
        img={determineImage()}
      />
      <p className="show-what-you-know__text">{determineDescriptionText()}</p>
      <PagerButton />
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ../core/src/components/ShowWhatYouKnow/ShowWhatYouKnowSpanish.js